export default defineNuxtPlugin(async () => {

    const { datadogRum } = await import("@datadog/browser-rum");

    const { $customClientErrorHandler } = useNuxtApp();

    const config = useRuntimeConfig();

    if(config.public.appEnvironment === 'local' || !config.public.ddApplicationId
        || !config.public.ddClientToken){
        return false;
    }

    function beforeSend(event, context) {
        // turn a "resource" error into an "ongoing issue" if backend returned a 400 or 500
        // because it means that frontend failed at guiding a user
        if (event.type === "resource" && (event.resource.status_code === 500
            || event.resource.status_code === 400)) {
            datadogRum.addError(new Error(`Bad request: ${event.resource.method} ${event.resource.url} ${event.resource.status_code}`), context);
        }
    }

    let options = {};

    try {

        const url = useRequestURL();

        /**
         * @description verify cookie consent first before sending user data to datadog
         */

        options = {
            beforeSend,
            applicationId: config.public.ddApplicationId,
            clientToken: config.public.ddClientToken,
            site: 'datadoghq.eu',
            service: 'eu24web-nuxt',
            env: config.public.appEnvironment,
            // Specify a version number to identify the deployed version of your application in Datadog
            version: config.public.version,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 20,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            trackViewsManually: true,
        }


        datadogRum.init(options);

        datadogRum.setGlobalContext({
            host: url.host
        });

        const authStore = useAuthStore();

        if (authStore.is_authenticated) {
            datadogRum.setUser({
                id: authStore.user.id,
                email: authStore.user.email,
                name: authStore.user.first_name + ' ' +authStore.user.last_name
            });
        }

        if(useRuntimeConfig().public.appDebug) {
            const debugStore = useDebugStore();
            debugStore.services.dataDogBrowserRum.enabled = true;
            debugStore.services.dataDogBrowserRum.clientToken = config.public.ddClientToken;
        }

        return {
            provide: {
                ddRum: datadogRum,
            },
        };

    } catch (error) {
        let errorMeta = {options, dataDogPluginError: true}

        $customClientErrorHandler(
            error,
            'high',
            'Datadog Rum Plugin Error - trying to monitoring services using datadog rum',
            errorMeta
        );
        return error;
    }
});
